import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Popup, Form, Button, Pager, Paging, FilterRow } from "devextreme-react/data-grid";
import ItemProperties from "../../components/itemProperties/ItemProperties";
import AddItemDialog from "./AddItemDialog";
import { useDispatch } from 'react-redux';
import { openEditItem, openItemDialog } from '../../store/item/itemDialogReducer'
import { Label } from "devextreme-react/form";
import { CommonSeriesSettingsHoverStyle } from "devextreme-react/chart";
import Title from "../../components/shared/Title";
import BlockHeader from "../../components/shared/BlockHeader";
import { cellRender } from "../../utils/common";
import { tipoArticulos } from "../../data/catalogos"
import { Link } from "react-router-dom";
import { _path } from "../../data/headerNavigation";



const descriptionEditorOptions = { height: 100 };

const Items = props => {

    const { title = 'Lista de articulos', typeId = 0 } = props;


    let dispatch = useDispatch();
    const gridRef = useRef();

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => gridRef.current.instance.exportToExcel(false)
            }
        }, {
            location: 'after',
            widget: 'dxButton',
            options: {
                stylingMode: "outlined",
                type: 'default',
                icon: 'add',
                text: IsService() ? 'Agregar servicio' : 'Agregar articulo',
                onClick: e => dispatch(openItemDialog(true))
            }
        });
    }

    const refreshGrid = () => {
        gridRef.current.instance.refresh();
    }

    const IsService = () => typeId == tipoArticulos.Mantenimiento;

    const IsBrandModelVisible = () => typeId == tipoArticulos.LentesDeContacto || typeId == tipoArticulos.MarcoAro;


    const IsLenses = () => typeId == tipoArticulos.LentesOftalmicos;
    const IsContactLenses = () => typeId == tipoArticulos.LentesDeContacto;
    const IsFrame = () => typeId == tipoArticulos.MarcoAro;
    const IsMaintenance = () => typeId == tipoArticulos.Mantenimiento;
    const IsAccesory = () => typeId == tipoArticulos.Accesorios;
    const IsEsclerales = typeId == tipoArticulos.LentesEsclerales;

    const getItemsUri = () => {
        switch (typeId) {
            case tipoArticulos.LentesOftalmicos: return uri.lensItems;
            case tipoArticulos.LentesDeContacto: return uri.contactLensItems;
            case tipoArticulos.MarcoAro: return uri.frameItems;
            case tipoArticulos.LentesEsclerales: return uri.scleralItems;
            default: return uri.itemsByType(typeId);
        }
    }

    return (
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} >
                {!IsFrame() && <Link to={`${_path.CLINICA}/articulos/marco`} className="btn btn-secondary">Marco/Aro</Link>}
                {!IsLenses() && <Link to={`${_path.CLINICA}/articulos/lentesOftalmicos`} className="btn btn-secondary" visible={false}>Lentes oftalmicos</Link>}
                {!IsContactLenses() && <Link to={`${_path.CLINICA}/articulos/lentesDeContacto`} className="btn btn-secondary">Lentes de contacto</Link>}
                {!IsEsclerales && <Link to={`${_path.CLINICA}/articulos/lentesEsclerales`} className="btn btn-secondary">Lentes Esclerales</Link>}
                {!IsAccesory() && <Link to={`${_path.CLINICA}/articulos/accesorios`} className="btn btn-secondary">Accesorios</Link>}
                {!IsService() && <Link to={`${_path.CLINICA}/articulos/servicio`} className="btn btn-secondary">Servicios</Link>}
            </BlockHeader>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <AddItemDialog updateParent={refreshGrid} typeId={typeId} />
                    <DataGrid
                        dataSource={store({ uri: { get: getItemsUri() }, remoteOperations: true })}
                        showBorders={true}
                        selection={{ mode: 'single' }}
                        showRowLines={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        hoverStateEnabled={true}
                        onToolbarPreparing={onToolbarPreparing}
                        rowAlternationEnabled={true}
                        remoteOperations={{
                            paging: true,
                            filtering: true
                        }}
                        ref={gridRef}
                    >
                        <Editing
                            // mode="popup"
                            allowUpdating={true}
                            allowDeleting={false}
                            allowAdding={false}
                            useIcons={true}

                        >

                        </Editing>
                        <Pager allowedPageSizes={[15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                        <Paging defaultPageSize={15} />
                        <FilterRow visible={true} />
                        <Column dataField="id" caption="Id" width={60} visible={false} allowEditing={false} />
                        <Column dataField="code" caption="Código" allowEditing={false} width={100}/>

                        {IsLenses() && <Column dataField="lensType" caption="Tipo de lente" />}
                        {IsLenses() && <Column dataField="material" caption="Material" />}
                        {IsLenses() && <Column dataField="treatment" caption="Tratamiento" />}
                        {IsLenses() && <Column dataField="color" caption="Color" />}
                        {/* { IsLenses() && <Column dataField="brand" caption="Marca" />} */}

                        {(IsContactLenses() || IsEsclerales) && <Column dataField="brand" caption="Marca" />}
                        {(IsContactLenses() || IsEsclerales) && <Column dataField="model" caption="Modelo" />}
                        {IsContactLenses() && <Column dataField="contactLensType" caption="Tipo" />}

                        {IsFrame() && <Column dataField="brand" caption="Marca" />}
                        {IsFrame() && <Column dataField="model" caption="Modelo" />}
                        {IsFrame() && <Column dataField="frameType" caption="Tipo" />}

                        {(IsMaintenance() || IsAccesory()) && <Column dataField="name" caption="Nombre" />}
                        {(IsMaintenance() || IsAccesory() || IsEsclerales) && <Column dataField="description" caption={IsEsclerales ? "Etiqueta" : "Descripción"} />}

                        {/* {IsEsclerales && <Column dataField="scleralType" caption="Tipo" />} */}

                        {!IsMaintenance() && <Column dataField="cost" caption="Costo" cellRender={cellRender()} />}
                        <Column dataField="price" caption="Precio Vta" cellRender={cellRender()} />
                        {!IsMaintenance() && <Column dataField="stock" caption="Stock" />}

                        <Column type="buttons">
                            <Button name="edit" onClick={(e) => { dispatch(openEditItem(e.row.data.id)); }} />
                        </Column>
                    </DataGrid>
                </Item>

            </Box>

        </div>
    );
}

export default Items;